// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__2ziFi","splash":"App_splash__vWto6","container":"App_container__eSJ6i","link":"App_link__1t642"};